<nav class="footer">
    <div class="navbar-expand m-auto  ">

        <div class="container-fluid  container" style=" padding: 20px; padding-top: 30px;padding-bottom: 20px;">
            <div class="row">
                <div class="col-md-3 col-sm-6 col-xs-6">
                    <div class="d-flex">
                        <p class="flex-grow-1" i18n>Alarabiya</p>
                        <div class="text-right vertical-divider"></div>
                    </div>


                    <ul>
                        <li><a href="" [routerLink]="'p/details/1'" i18n>Who we are</a></li>
                        <li><a href="" [routerLink]="'p/details/2'" i18n>Projects</a></li>
                        <li><a href="" [routerLink]="'/web/stores'" i18n>Showrooms</a></li>
                        <!--                        <li><a href="{{env.store360link}}" target="_blank" i18n>Virtual 360 Store</a></li>-->
                        <li><a href="" [routerLink]="'p/details/4'" i18n>Return Policy</a></li>
                        <li><a href="" [routerLink]="'p/details/4'" i18n>Terms and Conditions</a></li>
                        <li><a href="" [routerLink]="'p/details/5'" i18n>Privacy Policy</a></li>
                        <li><a href="https://company.alarabiya.com.kw/" i18n="@@companysite">Company Site</a></li>
                    </ul>

                </div>

                <!--                <div class="col-md-3 col-sm-12">-->
                <!--                    <p i18n>Research & Innovation</p>-->
                <!--                    <ul>-->
                <!--                        <li><a href="" i18n>General Information</a></li>-->
                <!--                        <li><a href="" i18n>Latest Innovations</a></li>-->
                <!--                        <li><a href="" i18n>Facts & Figures</a></li>-->
                <!--                        <li><a href="" i18n>Research news</a></li>-->
                <!--                    </ul>-->


                <!--                </div>-->
                <div class="col-md-3 col-sm-6 col-xs-6">
                    <div class="d-flex">
                        <p class="flex-grow-1" i18n>Contact us</p>
                        <div class="text-right vertical-divider"></div>
                    </div>
                    <ul>
                        <li ><span i18n="@@phone">Phone: </span><span style="    color: #30d1d7;margin-right: 5px;"> 1811311</span>
                          </li>
                        <li>  <a
                                href="https://wa.me/+9651811311"><i style="color: #04e904;"
                                                                    class="fa fa-whatsapp" i18n="@@whatsapp"></i> Whatsapp</a></li>
<!--                        <li i18n>International/Fax: <span style="    color: #30d1d7;">0096524710748</span></li>-->
                        <!--                        <li i18n>Customer Service | <span style="    color: #30d1d7;">22299990</span></li>-->
                        <!--                        <li i18n>Sales |<span style="    color: #30d1d7;">22220202</span></li>-->
                        <!--                        <li i18n>Projects Service | <span style="    color: #30d1d7;">22229000</span></li>-->
                    </ul>

                </div>
                <div class="col-md-3 col-sm-6 col-xs-6">
                    <div class="d-flex">
                        <p class="flex-grow-1" i18n="@@followuson">Follow us on</p>
                        <div class="text-right vertical-divider"></div>
                    </div>
                    <div class="social-links">
                        <!--                            <a href="#" class="fa fa-google"></a>-->
                        <a href="https://www.facebook.com/alarabiae1" class="fa fa-facebook"></a>
                        <a href="https://twitter.com/alarabiae1" class="fa">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style="fill: white;">
                                <path d="M453.2 112L523.8 112L369.6 288.2L551 528L409 528L297.7 382.6L170.5 528L99.8 528L264.7 339.5L90.8 112L236.4 112L336.9 244.9L453.2 112zM428.4 485.8L467.5 485.8L215.1 152L173.1 152L428.4 485.8z"/>
                            </svg>
                        </a>
                        <a href="https://www.instagram.com/alarabiae1/" class="fa fa-instagram"></a>
                        <a href="https://www.linkedin.com/in/al-arabiya-electrical-a8b248185"
                           class="fa fa-linkedin"></a>
                    </div>


                    <!--                    </div>-->
                    <!--                    <div class="row">-->
                    <!--                        <p class="contact-with" i18n></p>-->
                    <!--                        <div class="container">-->
                    <!--                            &lt;!&ndash;                            <a href="#" class="fa fa-google"></a>&ndash;&gt;-->
                    <!--                            <a href="https://www.facebook.com/alarabiae1" class="fa fa-facebook"></a>-->
                    <!--                            <a href="https://twitter.com/alarabiae1" class="fa fa-twitter"></a>-->
                    <!--                            <a href="https://www.instagram.com/alarabiae1/" class="fa fa-instagram"></a>-->
                    <!--                            <a href="https://www.linkedin.com/in/al-arabiya-electrical-a8b248185"-->
                    <!--                               class="fa fa-linkedin"></a>-->
                    <!--                        </div>-->

                    <!--                    </div>-->


                </div>
                <div class="col-md-3 col-sm-6 col-xs-6">
                    <div class="d-flex">
                        <p class="flex-grow-1" i18n="@@paywith">Pay with</p>
                    </div>
                    <app-payment-tags></app-payment-tags>


                </div>

            </div>


        </div>
        <div class="row p-2 pb-3">
            <div class="col-md-12 col-sm-12 text-right ">
                <div class="container  container-fluid ">
                    <div class="footer-text mini-menu">

<!--                        <a href="#" i18n>Contact Us </a>-->
<!--                        |-->
<!--                        <a href="#" i18n>Site Map </a>-->
<!--                        |-->
<!--                        <a href="#" i18n>Legal Disclaimer</a>-->

                    </div>
                </div>

            </div>
        </div>

        <!--        <hr class="solid">-->
        <!--        <mat-divider></mat-divider>-->

        <div class="mini-footer  p-4">
            <div class="container-fluid container ">
                <div class="d-flex ">
                    <div class="flex-grow-1  ">
                        <!--                <div class="row">-->
                        <!--                    <div class="col-6">-->
                        <!--                        <img style="max-width: 90px;" class="logo" src="assets/logoBlue.png"/>-->

                        <!--                    </div>-->
                        <div class=" ">
                            <img style="max-width: 60px;" class="logo" src="assets/logo_white.png"/>
                            <br>

                            <img style="max-width: 110px;" src="assets/Electronics%20Marketplace.png"/>

                        </div>
                        <!--                </div>-->


                        <!--      <div class="col-md-2 col-xs-12 text-right"><img class="logo text-right" src="assets/logo.png"/></div>-->


                    </div>
                    <div>
                        <div class="footer-text" i18n>Copyright © 2025 AlArabiya Electrical, All rights reserved.
                            Worldwide.
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</nav>
